import { render, staticRenderFns } from "./Paper.vue?vue&type=template&id=35490288&scoped=true"
import script from "./Paper.vue?vue&type=script&lang=js"
export * from "./Paper.vue?vue&type=script&lang=js"
import style0 from "./Paper.vue?vue&type=style&index=0&id=35490288&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35490288",
  null
  
)

export default component.exports